<template lang="pug">
.c-chat-rate.mt-12
  .u-txt--base.mb-8 Bagaimana pelayanan CS kami tadi?
  bl-flex-container-mv.mt-16(direction="row" alignItems="center" justifyContent="space-around")
    bl-flex-item-av
      .c-rate-icon.cursor-pointer(@click="giveRating('bad')")
        .c-rate-icon__wrap.u-thumb-down
          IcoThumbsdown(style="vertical-align: middle")
        .u-txt--fair.mt-8 Masih Kurang
    bl-flex-item-av
      .c-rate-icon.cursor-pointer(@click="giveRating('good')")
        .c-rate-icon__wrap.u-thumb-up
          IcoThumbsup(style="vertical-align: middle")
        .u-txt--fair.mt-8 Sudah Baik
</template>

<script>
import { BlTextAv, BlFlexContainerMv, BlFlexItemAv } from '@bukalapak/bazaar-mweb';
import IcoThumbsdown from '@bukalapak/bazaar-visual/dist/components/IcoThumbsdown';
import IcoThumbsup from '@bukalapak/bazaar-visual/dist/components/IcoThumbsup';

export default {
  name: 'ChatRate',
  components: {
    BlFlexContainerMv,
    BlFlexItemAv,
    BlTextAv,
    IcoThumbsdown,
    IcoThumbsup,
  },
  methods: {
    giveRating(rating) {
      this.$emit('ratingReceived', rating);
    },
  },
};
</script>

<style lang="scss" scoped>
.c-chat-rate {
  padding: 16px;
  border-radius: 2px;
  border: 1px solid rgb(221, 221, 221);
  min-width: 280px;
  width: 50vh;
  margin: auto;
}

.c-rate-icon {
  text-align: center;
  &__wrap {
    width: 40px;
    height: 40px;
    display: inline-block;
    border-radius: 20px;
    background: #f0f0f0;
  }
}

.u-thumb {
  &-up {
    line-height: 35px;
  }

  &-down {
    line-height: 40px;
  }
}

.cursor-pointer {
  cursor: pointer;
}
</style>
